module.exports = __webpack_public_path__ + "img/__icon_WYWROTKA.f2e99870.svg";